import React from 'react';
import { createRoot } from 'react-dom/client';
import Graph from './graph.js';

const root = createRoot(document.getElementById('root'));
root.render(<Graph />);
